import { createContext, ReactNode, useEffect, useState } from 'react';

// types
import { openSnackbar } from 'store/slices/snackbar';
import { useDispatch } from 'store';
import { GlobalProps, MainAccount } from 'types/global';
import { AccountsApi, getCurrentAccountId } from 'back_app';
import { useLocation } from 'react-router-dom';
// import helper from 'utils/helper';
import { closeConfirmation, openConfirmation,openGeneralAlertConfirmation } from 'store/slices/confirmation';
import { useIntl } from 'react-intl';

// initial state
const initialState: GlobalProps = {
    showSnackbar: (success: boolean, alert_text?: string, is_local_text?: boolean, handleSnackbarClosed?: () => void) => {},
    showConfirmation: (
        alert_text: string,
        message: string | JSX.Element,
        handleConfirmed: () => void,
        handleConfirmationClosed?: () => void,
        showDontShowAgain?: boolean
    ) => {},

    hideConfirmation: () => {},
    CurrentAccount: undefined,
    PageTitle: undefined,
    SetPageTitle: () => {},
    getLocalText: (key: string) => {}
    // SetCurrentAccountId: ()=>{}
};

// ==============================|| CONFIG CONTEXT & PROVIDER ||============================== //

const GlobalContext = createContext(initialState);

type GlobalProviderProps = {
    children: ReactNode;
};

function GlobalProvider({ children }: GlobalProviderProps) {
    const dispatch = useDispatch();
    const intl = useIntl();
    const { pathname } = useLocation();
    const [pageTitle, setPageTitle] = useState<string | undefined>();
    const [currentAccountId, setCurrentAccountId] = useState<number | undefined>();
    const [currentAccount, setCurrentAccount] = useState<MainAccount | undefined>();
    useEffect(() => {
        // reset title every new page
        setPageTitle(undefined);
        const account_id = getCurrentAccountId(pathname, false);
        setCurrentAccountId(account_id);
    }, [pathname]);

    useEffect(() => {
        if (!currentAccountId || currentAccountId <= 0) {
            setCurrentAccount(undefined);
        } else {
            AccountsApi.getMainAccount(currentAccountId).then((result: any) => {
                if (result) {
                    setCurrentAccount({
                        AccountId: result.ID,
                        AccountName: result.Name,
                        SubAccountId: result.SubAccountId ? result.SubAccountId : undefined,
                        SubAccountName: result.SubAccountName ? result.SubAccountName : undefined,
                        AccessPermissions: result.AccessPermissions,
                        AllowSubAccounts: result.AllowSubAccounts,
                        BrandColor: result.BrandColor,
                        Currency: result.Currency
                    });
                }
            });
        }
    }, [currentAccountId]);
    // vertical: 'bottom',
    //       horizontal: 'left'
    const showSnackbar = (
        success: boolean,
        alert_text?: string,
        is_local_text?: boolean,
        handleSnackbarClosed?: () => void,
        anchorOrigin?: { vertical: 'top' | 'bottom'; horizontal: 'left' | 'right' | 'center' },
        transition?: string
    ) => {
        dispatch(
            openSnackbar({
                open: true,
                message: is_local_text && alert_text ? getLocalText(alert_text) : alert_text,
                alert: {
                    color: success ? 'success' : 'error'
                },
                anchorOrigin: anchorOrigin || {
                    vertical: 'bottom',
                    horizontal: 'left'
                },
                transition: transition || 'SlideRight', // 'SlideRight' | 'SlideLeft' | 'SlideUp' | 'SlideDown'
                handleSnackbarClosed
            })
        );
    };

    const showConfirmation = (
        alert_text: string,
        message: string | JSX.Element,
        handleConfirmed: (dontShowAgain?: boolean) => void,
        handleConfirmationClosed?: () => void,
        showDontShowAgain?: boolean
    ) => {
        
        dispatch(
            openConfirmation({
                open: true,
                title: alert_text,
                children: <>{message}</>,
                handleConfirmed,
                handleConfirmationClosed: handleConfirmationClosed || hideConfirmation,
                onclose: hideConfirmation,
                showDontShowAgain
            })
        );
    };
    // const showGeneralAlertConfirmation= (
    //     alert_text: string,
    //     message: string | JSX.Element,
    //     handleConfirmed: () => void
    // ) => {
        
    //     dispatch(
    //         openGeneralAlertConfirmation({
    //             open: true,
    //             title: alert_text,
    //             children: <>{message}</>,
    //             handleConfirmed,
    //             handleConfirmationClosed: hideConfirmation,
    //             onclose: hideConfirmation,
    //         })
    //     );
    // };
    const hideConfirmation = () => {
        // console.log('global_hideConfirmation');
        dispatch(closeConfirmation());
    };
    const SetCurrentAccount = (account: MainAccount | undefined) => {
        setCurrentAccount(account);
    };

    const handlePageTitle = (title?: string) => {
        setPageTitle(title);
    };

    const normalizeKey = (key: string) => {
        return key;
        const norm = key.trim().toLowerCase();
        return norm;
    };

    const getLocalText = (key: string) => {
        if (!key) {
            return '';
        }
        const local_text = intl.formatMessage({ id: normalizeKey(key) });
        return local_text;
    };
    return (
        <GlobalContext.Provider
            value={{
                showSnackbar,
                showConfirmation,
              //  showGeneralAlertConfirmation,
                hideConfirmation,
                CurrentAccount: currentAccount,
                PageTitle: pageTitle,
                SetPageTitle: handlePageTitle,
                getLocalText
                // SetCurrentAccountId: setCurrentAccountId,
            }}
        >
            {children}
        </GlobalContext.Provider>
    );
}

export { GlobalProvider, GlobalContext };
